import script from "./PrimarySponsorContractFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimarySponsorContractFormView.vue?vue&type=script&setup=true&lang=js"

import "./PrimarySponsorContractFormView.vue?vue&type=style&index=0&id=50a08894&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a08894"]])

export default __exports__